var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M21 6a1 1 0 0 1 1-1h2v14h-2a1 1 0 0 1-1-1V6ZM0 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H0V5Zm5 1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }